import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { SwitchYearDialogViewModel } from './SwitchYearDialogViewModel'

export { SwitchYearDialogViewModel } from './SwitchYearDialogViewModel'

interface SwitchYearDialogProps {
  vm: SwitchYearDialogViewModel
  testId?: string
}

export const SwitchYearDialog = observer(function SwitchYearDialog({
  vm,
  testId,
}: SwitchYearDialogProps) {
  const isSaving = vm.saveAndContinue.pending

  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable={!isSaving}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Save your changes before switching years
        </ModalDialogTitle>
        <ModalDialogDescription>
          Make sure this year&apos;s info is accurate and complete before moving
          to {vm.targetYear?.year}.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Save and continue"
            variant="default"
            onPress={vm.saveAndContinue}
            isPending={isSaving}
            testId={testId ? `${testId}-save-button` : undefined}
          />
          <Button
            label="Continue without saving"
            variant="outline"
            onPress={vm.continueWithoutSaving}
            isDisabled={isSaving}
            testId={testId ? `${testId}-continue-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
